import React from 'react';
import LifeSkill from 'views/LiteraryClub';

const LifeSkillPage = () => {
  return <LifeSkill/>;
};

export default LifeSkillPage;